import { photos } from './site'

const uploads = 'https://basmenninga.nl/wp-content/uploads'

export const offers = [
  {
    to: '/optreden',
    title: 'Live optreden',
    text: 'Gitaar of piano en stem voor uw borrel, feest of viering. Van ingetogen dinermuziek tot meezingers als de avond vordert.',
    meta: 'Offerte op maat',
    image: photos.stage,
    imagePosition: '40% 50%',
  },
  {
    to: '/muziekles',
    title: 'Piano- & gitaarles',
    text: 'Voor beginners en gevorderden, jong en oud. Een stevige basis én de liedjes die jij graag wilt spelen.',
    meta: 'Vanaf € 30 per les',
    image: photos.piano,
    imagePosition: '50% 30%',
  },
  {
    to: '/workshops',
    title: 'Ukelele-workshop',
    text: 'Speel de Uke: in anderhalf uur van nul naar je eerste popliedjes. Voor teamuitjes, bedrijven en verjaardagen.',
    meta: '± 1,5 uur · geen ervaring nodig',
    image: photos.ukulele,
    imagePosition: '50% 55%',
  },
]

export const videos = [
  {
    src: `${uploads}/2024/04/b5a3c67d-9027-4a48-8604-6ffb71c05ca1.mp4`,
    title: 'Mooie dag',
    artist: 'BLØF',
    context: 'Afstudeerconcert Conservatorium van Amsterdam, 2023 · arrangement Bas Menninga',
  },
  {
    src: `${uploads}/2022/05/WhatsApp-Video-2022-05-03-at-12.11.39.mp4`,
    title: 'Als ze er niet is',
    artist: 'De Dijk',
    context: 'Theater Blaricum, 2022',
  },
  {
    src: `${uploads}/2020/12/VID-20201229-WA00011.mp4`,
    title: 'Zolang de liefde maar blijft winnen',
    artist: 'Daniël Lohues',
    context: 'O.l.v. Thijmen Jacobse, 2020',
  },
  {
    src: `${uploads}/2020/01/bas-imagine-klein.mp4`,
    title: 'Imagine',
    artist: 'John Lennon',
    context: 'Solo aan de piano',
  },
  {
    src: `${uploads}/2018/09/VID-20180914-WA0006.mp4`,
    title: 'Medley',
    artist: 'Bas Menninga',
    context: 'Live, 2018',
  },
]

export const gallery = [
  { src: photos.stage, alt: 'Bas zingt achter de microfoon onder paars en oranje podiumlicht' },
  { src: photos.guitarSmile, alt: 'Bas lacht en speelt gitaar onder de bomen op de heide' },
  { src: photos.piano, alt: 'Bas lachend aan de piano in een lichte woonkamer' },
  { src: photos.guitarFocus, alt: 'Bas kijkt geconcentreerd naar zijn gitaar in het zonlicht' },
  { src: photos.riverside, alt: 'Bas leunt op een reling langs de rivier in de avondschemering' },
  { src: photos.guitarGarden, alt: 'Bas met akoestische gitaar voor een groene haag' },
  { src: photos.ukulele, alt: 'Een ukelele in het gras voor een gele windmolen' },
  { src: photos.guitarPlaying, alt: 'Bas speelt gitaar met gebogen hoofd, bomen op de achtergrond' },
  { src: photos.portraitEvening, alt: 'Portret van Bas met sjaal bij avondlicht' },
  { src: photos.street, alt: 'Bas lachend in een zonnige straat' },
]

export const press = [
  {
    source: 'NH Gooi',
    title: 'Singer-songwriter Bas Menninga opent de Brugparade in Huizen',
    date: 'September 2026',
    href: 'https://nhgooi.nl/nieuws/6401593/muziek-theater-botters-komen-samen-brugparade-huizen',
  },
  {
    source: 'Hei & Wei',
    title: 'Even voorstellen… Bas Menninga, muzikant',
    date: 'Mei 2025',
    href: 'https://heienwei.nl/even-voorstellen-bas-menninga-muzikant/',
  },
  {
    source: 'Radio Laren · Gooische Business',
    title: '“Onze huisminstreel” over zijn nieuwe kerstsingle',
    date: 'December 2024',
    href: 'https://nederlandse-podcasts.nl/podcast/gooische-business-nhgib/gb-20241206-bas-menninga-vliegdenweg-bussum-en-win',
  },
  {
    source: 'Dijksound',
    title: 'Dirigent van het koor',
    date: 'Doorlopend',
    href: 'https://dijksound.nl/home/home/onze-dirigent/',
  },
]

export const timeline = [
  { year: '1998', text: 'Geboren in Blaricum. Thuis draaien Queen in Wembley, The Eagles, Procol Harum en Dire Straits.' },
  { year: '2005', text: 'Na lang smeken op mijn zevende mijn eerste gitaar. Jaren klassieke les, later vrije les en songwriting.' },
  { year: 'Daarna', text: 'Zang- en pianoles erbij, om als singer-songwriter verder te kunnen. Eerst nog een hbo Bedrijfskunde.' },
  { year: '2023', text: 'Docentenopleiding Muziek aan het Conservatorium van Amsterdam afgerond.' },
  { year: 'Nu', text: 'Docent muziek en economie, piano- en gitaarleraar, dirigent, en te boeken voor uw gelegenheid.' },
]

export const performance = {
  occasions: [
    { title: 'Bedrijfsborrels & recepties', text: 'Sfeervol op de achtergrond, of juist het moment waarop de zaal gaat meezingen.' },
    { title: 'Verjaardagen & jubilea', text: 'Een setlist rond de muziek van de jarige — Hazes, BLØF of Hotel California.' },
    { title: 'Vieringen & bruiloften', text: 'Ingetogen waar het moet, feestelijk waar het kan.' },
    { title: 'Kerst- & eindejaarsborrels', text: 'Van Driving home for Christmas tot Sinterklaas, wie kent hem niet.' },
    { title: 'Dorpsfeesten & evenementen', text: 'Zoals de opening van de Brugparade in Huizen.' },
  ],
  steps: [
    { title: 'Kennismaken', text: 'U vertelt over de gelegenheid, de gasten en de sfeer die u voor ogen heeft. Binnen een werkdag hoort u van mij.' },
    { title: 'Muziek op maat', text: 'Samen stellen we een setlist samen uit mijn repertoire. Verzoeknummers? Die studeer ik graag voor u in.' },
    { title: 'De avond zelf', text: 'Ik speel wat er op dat moment gevraagd wordt en lees de zaal — letterlijk de juiste snaar raken.' },
  ],
  faq: [
    { q: 'Wat kost een optreden?', a: 'Elke gelegenheid is anders: duur, locatie en wensen bepalen de prijs. Na een kort gesprek ontvangt u een heldere, vrijblijvende offerte.' },
    { q: 'Kan ik verzoeknummers aanvragen?', a: 'Zeker. Staat een nummer niet in het repertoire, dan kijk ik graag of ik het voor uw gelegenheid kan instuderen.' },
    { q: 'Speelt u op gitaar of op piano?', a: 'Allebei. We kiezen samen wat het beste bij de ruimte en de sfeer past.' },
    { q: 'In welke regio treedt u op?', a: 'Vanuit Huizen speel ik vooral in het Gooi en omstreken, maar voor een mooie gelegenheid rijd ik graag verder.' },
  ],
}

export const lessons = {
  prices: [
    { duration: '30 minuten', price: '€ 30', note: 'Ideaal voor beginners en jonge leerlingen' },
    { duration: '60 minuten', price: '€ 60', note: 'Meer ruimte voor verdieping en eigen repertoire' },
  ],
  approach: [
    { title: 'Een stevige basis', text: 'Met een lesmethode vanuit de klassieke traditie leer je muziek écht spelen én begrijpen.' },
    { title: 'Jouw liedjes', text: 'Tegelijk werken we aan de songs die jij wilt spelen, zodat je jezelf snel kunt begeleiden.' },
    { title: 'Jij bepaalt de route', text: 'Andere wensen, zoals zelf schrijven of een specifieke stijl? Alles is bespreekbaar.' },
  ],
  faq: [
    { q: 'Ben ik niet te oud om te beginnen?', a: 'Nooit. Jong, oud en alles daartussen: je bent nooit te oud om gitaar of piano te leren spelen.' },
    { q: 'Heb ik al ervaring nodig?', a: 'Nee. Zowel beginners als gevorderde spelers zijn welkom; we starten waar jij staat.' },
    { q: 'Waar vinden de lessen plaats?', a: 'De lessen zijn in Huizen. Na je aanmelding ontvang je alle praktische details.' },
    { q: 'Heb ik een eigen instrument nodig?', a: 'Om thuis te oefenen wel. Twijfel je over een aankoop? Ik denk graag met je mee.' },
  ],
}

export const workshop = {
  outcomes: [
    { title: 'Stemmen', text: 'Je leert je ukelele zelf stemmen, zodat hij altijd goed klinkt.' },
    { title: 'Ritme', text: 'Een constant slagritme, de motor onder elk liedje.' },
    { title: 'Akkoorden & liedjes', text: 'Met een paar basisakkoorden speel je samen je eerste popliedjes.' },
  ],
  audiences: ['Bedrijfsuitjes', 'Teambuilding', 'Verjaardagen', 'Jong en oud'],
  details: [
    { label: 'Duur', value: 'Ongeveer anderhalf uur' },
    { label: 'Ervaring', value: 'Niet nodig' },
    { label: 'Voor wie', value: 'Groepen, jong en oud' },
    { label: 'Locatie & groepsgrootte', value: 'In overleg' },
  ],
}
